export default {
  schedule: {
    date_and_time: 'Päivä ja aika*',
    number_of_guests: 'Vieraiden määrä*',
    location: 'Sijainti:',
  },
  personal_information: {
    title: 'Titteli',
    first_name: 'Etunimi',
    enter_first_name: 'Anna etunimi',
    last_name: 'Sukunimi*',
    enter_last_name: 'Anna sukunimi',
    email: 'Sähköposti',
    enter_email: 'Anna sähköposti',
    phone: 'Puhelin',
    annotation: 'Lisätieto',
    enter_annotation: 'Anna lisätieto',
  },
  gender: {
    without_title: 'Ei titteliä',
    male: 'Herra',
    female: 'Rouva',
  },
  buttons: {
    save: 'Tallenna',
  },
  error_messages: {
    invalid_email: 'Anna kelvollinen sähköpostiosoite ilman välilyöntejä tai ä/ö-kirjaimia ennen @-merkkiä.',
    invalid_phone_number: 'Virheellinen puhelinnumero. Tarkista tietosi ja yritä uudelleen.',
    failed_reservation: 'Varauksen lähettäminen epäonnistui. Tarkista tietosi ja yritä uudelleen.',
    invalid_reservation_day: 'Emme ota vastaan varauksia tälle päivälle.',
    no_tables_available: 'Valitettavasti meillä ei ole enää vapaita pöytiä.',
    please_enter_guests: 'Anna vieraiden määrä.',
    please_select_time: 'Valitse aika.',
    please_select_last_name: 'Valitse sukunimi',
  },
  success_messages: {
    reservation_saved: 'Varaus tallennettu onnistuneesti',
  },
};
